import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import RequestAccessModal from './RequestAccessModal';
import { useToast } from './Toast';
import { Shield } from 'lucide-react';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [showRequestModal, setShowRequestModal] = useState(false);
  const toast = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      setError("Error al iniciar sesión. Verificá tus credenciales.");
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!resetEmail.trim()) return;
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      toast.success("Correo de recuperación enviado. Revisá tu bandeja de entrada y spam.");
      setShowReset(false);
      setResetEmail('');
    } catch {
      toast.error("Error al enviar el correo. Verificá la dirección.");
    }
  };

  return (
    <div className="login-page">
      <div className="card login-card">
        <div className="card-body">
          <div className="login-brand">
            <Shield size={32} />
          </div>
          <h1 className="login-title">Fleet Check</h1>

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="login-email" className="form-label">Correo electrónico</label>
              <input
                id="login-email"
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="login-password" className="form-label">Contraseña</label>
              <input
                id="login-password"
                type="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                required
              />
            </div>

            <button
              type="button"
              className="login-link"
              onClick={() => setShowReset(!showReset)}
            >
              ¿Olvidaste tu contraseña?
            </button>

            {showReset && (
              <div className="form-group" style={{ background: 'var(--color-bg-alt)', padding: 'var(--space-md)', borderRadius: 'var(--radius-md)', marginBottom: 'var(--space-md)' }}>
                <label htmlFor="reset-email" className="form-label">Email para recuperar</label>
                <input
                  id="reset-email"
                  type="email"
                  className="form-input"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  placeholder="tu@email.com"
                />
                <button
                  type="button"
                  className="btn btn-outline btn-sm btn-full"
                  onClick={handlePasswordReset}
                  style={{ marginTop: 'var(--space-sm)' }}
                >
                  Enviar correo de recuperación
                </button>
              </div>
            )}

            {error && <p className="form-error" role="alert" style={{ textAlign: 'center', marginBottom: 'var(--space-md)' }}>{error}</p>}

            <button type="submit" className="btn btn-primary btn-full btn-lg">
              Iniciar sesión
            </button>
          </form>

          <button
            onClick={() => setShowRequestModal(true)}
            className="btn btn-outline btn-full"
            style={{ marginTop: 'var(--space-md)' }}
          >
            Solicitar acceso
          </button>
        </div>
      </div>

      <p className="login-footer">&copy; 2026 Powered by <a href="https://vynex.ar" target="_blank" rel="noopener noreferrer" className="login-footer-link">VYNEX</a></p>

      {showRequestModal && (
        <RequestAccessModal onClose={() => setShowRequestModal(false)} />
      )}
    </div>
  );
}

export default Login;
